<template>
	<section class="small-12 large-6 columns animated fadeIn flex vertical-align" v-if="property">
		<div class="auto columns sectionIcon">
			<picture class="flex justify-center vertical-align borderRadius8 bgLightGreen">
				<i class="material-icons-outlined">home_work</i>
			</picture>
		</div>
		<div class="small-10">
			<div class="small-12 pageTitleBar">
				<ul class="small-12 float-left flex vertical-align">
					<li class="float-left">
						<h2 v-html="truncatedTitle" v-if="property.attributes.title"></h2>
						<h2 v-html="truncatedAddress" v-else></h2>
					</li>
					<li class="auto float-left" style="margin-left:3px;">
						<a class="borderRadius4 flex justify-center vertical-align animated icon">
							<i class="material-icons-outlined">expand_more</i>
						</a>
					</li>	
					<li class="auto float-left">
						<a class="borderRadius4 flex justify-center vertical-align animated icon">
							<i class="material-icons-outlined float-left">information</i>
						</a>
					</li>
					<li class="auto float-left">
						<a class="borderRadius4 flex justify-center vertical-align animated icon">
							<i class="material-icons-outlined">favorite_border</i>
						</a>
					</li>
				</ul>
			</div>
			<nav class="small-12 siteSectionNav">
				<ul class="small-12 flex vertical-align">
					<li class="flex vertical-align">
						<router-link class="flex vertical-align justify-center" :to="{ name: 'PropertyDetails' }">
							Overview
						</router-link>
					</li>
					<li class="flex vertical-align" v-if="futureItem">
						<router-link class="flex vertical-align justify-center" :to="{ name: 'PropertyOperations' }">
							Operations
						</router-link>
					</li>
					<li class="flex vertical-align">
						<router-link class="flex vertical-align justify-center router-link-exact-active router-link-active" :to="{ name: 'PropertyUnits' }"  v-if="$route.name == 'Unit'">
							Units
						</router-link>
						<router-link class="flex vertical-align justify-center" :to="{ name: 'PropertyUnits' }" v-else>
							Units
						</router-link>
					</li>
					<li class="flex vertical-align">
						<router-link class="flex vertical-align justify-center router-link-exact-active router-link-active" :to="{ name: 'PropertyResidents' }" v-if="$route.name == 'Resident' || $route.name == 'LeaseRent'">
							Residents
						</router-link>
						<router-link class="flex vertical-align justify-center" :to="{ name: 'PropertyResidents' }" v-else>
							Residents
						</router-link>
					</li>
					<li class="flex vertical-align" v-if="futureItem">
						<router-link class="flex vertical-align justify-center" :to="{ name: 'PropertyTaxes' }">
							Taxes
						</router-link>
					</li>
					<li class="flex vertical-align" v-if="futureItem">
						<router-link class="flex vertical-align justify-center" :to="{ name: 'PropertyAppraisals' }">
							Appraisals
						</router-link>
					</li>
					<li class="flex vertical-align" v-if="futureItem">
						<router-link class="flex vertical-align justify-center" :to="{ name: 'PropertyReporting' }">
							Reporting
						</router-link>
					</li>
					<li class="flex vertical-align" v-if="futureItem">
						<router-link class="flex vertical-align justify-center" :to="{ name: 'PropertySettings' }">
							Settings
						</router-link>
					</li>
				</ul>
			</nav>
		</div>
	</section>
</template>

<script>

	// Import the helpers
	import { Truncate } from '@/mixins/helpers/Truncate'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'PropertyNav',

		/*
		**  Register the mixins
		*/

		mixins: [

			Truncate

		],

		/*
		**  Set up the data
		*/

		data: () => ({

			futureItem: false,
			truncatedTitle: null,
			truncatedAddress: null

		}),

		/*
		**  Set the props
		*/

		props: {

			property: {
				type: Object,
				default: () => null
			}

		},

		/*
		**  Watch em'
		*/

		watch: {

			property: {

				immediate: true, // Load on created
				handler(property) {

					/*
                    ** Truncate the property nickname
                    ** @method: Mixins/Helpers/Truncate
                    */

				   	if (property && property.attributes.title) {

						this.truncatedTitle = this.truncateString(property.attributes.title, 40);

					} else {

						this.truncatedAddress = this.truncateString(property.attributes.address.street_1, 40);

					}

				}

			}

		},

	}

</script>